module.exports = __webpack_public_path__ + "img/bank_img2.1de60aed.png";